export { default } from './ForgetPassword';



// WEBPACK FOOTER //
// ./src/components/UserAccount/ForgetPassword/index.js